<template>
  <dialog class="modal" :class="{ 'modal-open': open }">
    <div class="modal-box">
      <h3 class="text-lg font-bold">Tạo người dùng mới</h3>
      <form @submit="onSubmit">
        <div class="space-y-4 py-4">
          <fieldset class="fieldset">
            <legend class="fieldset-legend">Tên đăng nhập</legend>
            <input
              v-model="username"
              type="text"
              class="input input-bordered w-full"
              :class="{ 'input-error': errors.username }"
              placeholder="Nhập tên đăng nhập"
            />
            <p v-if="errors.username" class="label text-error">
              {{ errors.username }}
            </p>
          </fieldset>

          <fieldset class="fieldset">
            <legend class="fieldset-legend">Mật khẩu</legend>
            <input
              v-model="password"
              type="password"
              class="input input-bordered w-full"
              :class="{ 'input-error': errors.password }"
              placeholder="Nhập mật khẩu"
            />
            <p v-if="errors.password" class="label text-error">
              {{ errors.password }}
            </p>
          </fieldset>

          <fieldset class="fieldset">
            <legend class="fieldset-legend">Xác nhận mật khẩu</legend>
            <input
              v-model="confirmPassword"
              type="password"
              class="input input-bordered w-full"
              :class="{ 'input-error': errors.confirmPassword }"
              placeholder="Nhập lại mật khẩu"
            />
            <p v-if="errors.confirmPassword" class="label text-error">
              {{ errors.confirmPassword }}
            </p>
          </fieldset>

          <fieldset class="fieldset">
            <legend class="fieldset-legend">Vai trò</legend>
            <select
              v-model="role"
              class="select select-bordered w-full"
              :class="{ 'select-error': errors.role }"
            >
              <option value="operator">Operator</option>
              <option value="admin">Admin</option>
            </select>
            <p v-if="errors.role" class="label text-error">
              {{ errors.role }}
            </p>
          </fieldset>
        </div>
        <div class="modal-action">
          <button type="button" class="btn" @click="closeModal">Đóng</button>
          <button
            type="submit"
            class="btn btn-primary ml-2"
            :disabled="isCreating"
          >
            <span v-if="isCreating" class="loading loading-spinner"></span>
            Tạo người dùng
          </button>
        </div>
      </form>
    </div>
    <form method="dialog" class="modal-backdrop">
      <button @click="closeModal">close</button>
    </form>
  </dialog>
</template>

<script setup lang="ts">
import { useCreateUserMutation } from "@/composables/useUser";
import { useForm } from "vee-validate";
import { watch } from "vue";
import { toast } from "vue3-toastify";

const open = defineModel<boolean>("open", { default: false });

const { defineField, handleSubmit, errors, resetForm } = useForm({
  initialValues: {
    username: "",
    password: "",
    confirmPassword: "",
    role: "operator",
  },
  validationSchema: {
    username: "required|min:4|max:50",
    password: "required|min:8|max:64|password_complex",
    confirmPassword: "required|confirmed:@password",
    role: "required",
  },
});

const [username] = defineField("username", { label: "Tên đăng nhập" });
const [password] = defineField("password", { label: "Mật khẩu" });
const [confirmPassword] = defineField("confirmPassword", {
  label: "Xác nhận mật khẩu",
});
const [role] = defineField("role");

const { mutate: createUser, isPending: isCreating } = useCreateUserMutation();

const onSubmit = handleSubmit((values) => {
  createUser(
    {
      username: values.username,
      password: values.password,
      role: values.role || "operator",
    },
    {
      onSuccess: () => {
        toast.success("Tạo người dùng thành công!");
        closeModal();
      },
      onError: () => {
        toast.error("Đã xảy ra lỗi khi tạo người dùng.");
      },
    },
  );
});

const closeModal = () => {
  open.value = false;
  resetForm();
};

watch(open, (newVal) => {
  if (newVal) {
    resetForm();
  }
});
</script>
